<template lang="pug">
  .animated-flip-counter(ref="tick")
    span(v-show="value" :class="[currencySignOnTheRight ? '-right-ds-xl' : '-left-ds-xl', 'absolute top-0 text-black70 text-rebrandLg sm:text-rebrand2xm md:text-rebrandLg lg:text-rebrandXl xl:text-rebrand3xl']") {{ $t("summary.currency") }}
</template>

<script lang="ts">
import "@pqina/flip/dist/flip.min.css"
import "@pqina/flip/dist/tick.view.flip.css"
import { LOCALE } from "~/constants/locale"

export default {
  name: "AnimatedFlipCounter",

  props: {
    value: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      _tickInstance: null
    }
  },

  mounted() {
    this.initializeTick()
  },

  computed: {
    currencySignOnTheRight() {
      const currencySignOnTheRightCountries = [LOCALE.ES, LOCALE.FR]
      return currencySignOnTheRightCountries.includes(this.$i18n.locale)
    }
  },

  methods: {
    initializeTick() {
      const element = this.$refs.tick
      if (element) {
        this._tickInstance = this.$tick.DOM.create(element, {
          value: Math.floor(this.value),
          format: {
            transform: value => Math.floor(value)
          },
          // definition for top level tick element
          view: {
            children: [
              // presenter object
              {
                root: "div",
                layout: "group",
                repeat: true,
                children: [
                  // presenter object
                  {
                    view: "flip"
                  }
                ]
              }
            ]
          },
          didInit: tick => {
            // use this lifecycle hook if you need
          }
        })
      } else {
        console.error("Tick element not found")
      }
    }
  },

  watch: {
    value(newValue) {
      if (this._tickInstance) {
        this._tickInstance.value = Math.floor(newValue)
      }
    }
  },

  beforeUnmount() {
    if (this._tickInstance) {
      this.$tick.DOM.destroy(this._tickInstance)
    }
  }
}
</script>

<style module>
:global(.animated-flip-counter) {
  @apply text-rebrandLg sm:text-rebrand2xm md:text-rebrandLg lg:text-rebrandXl xl:text-rebrand3xl inline-block min-h-[80px] whitespace-nowrap;
}
:global(.tick-credits) {
  @apply hidden;
}
</style>
